import { IAngularEvent, IHttpService, ILocationService, IQService, ITimeoutService, IWindowService } from "angular";
import { CommandPaletteService } from 'ng/src/app/shared/command-palette/command-palette.service';
import { CookieService } from "ngx-cookie-service";
import { PrimeIcons } from 'primeng/api';
import { IRouteEventRoute, IRouteService } from "../shared/model/route.model";
import { NotificationService } from 'ng/src/app/notifications/notification.service';
import { TemplateType } from "ng/src/app/templates/shared/template.model";
import { Report, ReportOutputType } from "../../ng/src/app/reports/report.model";
import type { Notification } from "ng/src/app/notifications/notification.model";
import { LogBookRootScopeService } from "../shared/model/app.model";
import { Log } from "../../ng/src/app/logs/log.model";
import { LogService } from "../../ng/src/app/logs/log.service";
import { Note } from "../../ng/src/app/notes/shared/note.model";
import { HALResponse } from 'ng/src/app/shared/model/app.model';
import { ServiceWorkerService } from "service-worker/service-worker.service";
import { Subscription } from "rxjs";
import { ServiceWorkerEvents } from "../../service-worker/service-events";
import { AppStateService } from "ng/src/app/core/services/app-state.service";
import { PersistentDialogService } from "ng/src/app/shared/persistent-dialog/persistent-dialog.service";
import { VideoTipsViewerComponent } from "ng/src/app/core/changelog-viewer/video-tips-viewer.component";
import { LogBookService } from "ng/src/app/core/services/logbook.service";
import { HelpSection } from "ng/src/app/core/help-section";
import { SystemNotificationService } from "ng/src/app/notifications/system-notification.service";

angular.module('logbook')
    .directive('navbar', ['$http', '$route', '$window', '$rootScope', '$timeout', 'logDataService', 'notificationService', '$location', '$q', 'logService', 'serviceWorkerService', 'persistentDialogService', 'logBookService', 'systemNotificationService', 'cookieService', 'commandPaletteService',
		function($http: IHttpService, $route: IRouteService, $window: IWindowService, $rootScope: LogBookRootScopeService, $timeout: ITimeoutService, logDataService, notificationService: NotificationService, $location: ILocationService, $q: IQService, logService: LogService, serviceWorkerService: ServiceWorkerService, persistentDialogService: PersistentDialogService, logbookService: LogBookService, systemNotificationService: SystemNotificationService, cookieService: CookieService, commandPaletteService: CommandPaletteService) {
            return {
                redirect: 'E',

                scope: {
                    tab: '=',
                    user: '=',
                    logout: '=',
                    selectedLog: '=',
                    logs: '=',
                    notification: '=?',
					          bellCount: '=?'
                },

                template: require('./navbar.html'),
                link: {
                    pre: function(scope, elem) {
                        Object.defineProperty(scope, 'showNavBar', {
                            get: () => scope._showNavBar ?? true,
                            set(v: boolean) {
                                if (cookieService.get('hide-navbar') == 'true' || $location.search()['hideNavBar']) {
                                    v = false;
                                }
                                
                                scope._showNavBar = v;
                                elem.find('#main-navbar').toggleClass('p-d-none', !v);
                            }
                        });
                        
                        scope.showNavBar = $route.current?.$$route?.showNavBar ?? false;
                    },
                    post: function(scope, elem) {
                        // TODO: Remove this and use the template ref variable for the fab component in the new ng navbar
                        scope.closeFab = ($event?: Event) => AppStateService.closeFab($event);
                        scope.onHomePage = false;
                        
                        scope.hasHover = () => AppStateService.hoverSupported;
                        
                        scope.showAdminNavigation = () => {
                            try {
                                return AppStateService.isAdmin && AppStateService.hasAdminUiFlag;
                            }
                            catch (e) {
                                return false;
                            }
                        };
                        
                        commandPaletteService.register({
                            group: 'Navigation',
                            label: 'Log Home',
                            title: 'Go to log home',
                            icon: PrimeIcons.COMPASS,
                            command: () => {
                                $location.path('/notes');
                            },
                        }, {
                            group: 'Navigation',
                            label: 'Search Notes',
                            title: 'Go to note search',
                            icon: PrimeIcons.COMPASS,
                            command: () => {
                                $location.path('/note-query');
                            },
                        }, {
                            group: 'Navigation',
                            label: 'Log Settings',
                            title: 'Go to log settings',
                            icon: PrimeIcons.COMPASS,
                            command: () => {
                                $location.path('/log-detail');
                            }
                        })
                        
                        let serviceWorkerDefer = $q.defer<ServiceWorkerRegistration | undefined>();
                        $rootScope.serviceWorker = serviceWorkerDefer.promise;
                        
                        scope.notificationService = notificationService;
                        
                        scope.baseUrl = $location.absUrl().split("/#")[0];
                        
                        if (scope.baseUrl[scope.baseUrl.length - 1] == '/')
                            scope.baseUrl = scope.baseUrl.slice(0, scope.baseUrl.length - 1);
                        
                        scope.shotSentinel = false;
                        
                        let $hamburger = elem.find('#hamburger');
                        let $noHoverDefaultNote: JQLite | undefined = undefined;
                        let $navbarCollapse: JQLite | undefined = undefined;
                        
                        elem.on({
                            // Should fire before mouseenter on browsers that support it.
                            pointerenter: function(event) {
                                scope.isTouchPointer = event?.pointerType != 'mouse';
                                
                                // Some devices have both pointer and touch capability
                                if ($rootScope.hoverSupported && scope.isTouchPointer) {
                                    if (!$noHoverDefaultNote)
                                        $noHoverDefaultNote = $('#no-hover-default-note');
                                    
                                    // Better UX than relying on an ng-if scope binding because of the digest cycle lag
                                    $noHoverDefaultNote.addClass('show')
                                }
                            },
                            mouseenter: function() {
                                if ($rootScope.hoverSupported && !scope.isTouchPointer) {
                                    if ($noHoverDefaultNote)
                                        $noHoverDefaultNote.removeClass('show');
                                    
                                    $(this).addClass('open');
                                }
                            },
                            mouseleave: function() {
                                if ($rootScope.hoverSupported && !scope.isTouchPointer)
                                    $(this).removeClass('open');
                            }
                        }, '.dropdown');
                        
                        elem.on('click', 'a:not(.dropdown-toggle)', function() {
                            if (!$navbarCollapse)
                                $navbarCollapse = elem.find('#navbar-collapse');
                            
                            $navbarCollapse.collapse('hide');
                        });
                        
                        scope.hasVideos = () => {
                            return !!logbookService.getConfigValue('hasVideoGuides')
                        }
                        
                        const updateBellCount = () => {
                            const combined = notificationService.unreadCount + systemNotificationService.getUnreadCount();
                            return scope.bellCount = combined === 0 ? '' : combined > 10 ? '9+' : combined.toString();
                        }
                        
                        // Notification Service subscriptions and management
                        const subs = new Subscription();
                        subs.add(notificationService.bellCount$.subscribe(() => updateBellCount()));
                        subs.add(systemNotificationService.getPoll().subscribe(() => updateBellCount()));
                        subs.add(serviceWorkerService.ready$.subscribe(function(v) {
                            if (v) {
                                subs.add(serviceWorkerService.registerForEvent<Notification.Projections.WithLogName[]>(ServiceWorkerEvents.TOAST_UPDATE).subscribe(function(toasts) {
                                    if (!serviceWorkerService.notificationsAllowed)
                                        scope.setToasts(toasts);
                                }));
                            }
                        }));
                        subs.add(notificationService.openNotificationNote$.subscribe(function(note) {
                            scope.openNote(note);
                        }));
                        scope.$on('$destroy', function() {
                            subs.unsubscribe();
                        });
                        
                        scope.showHelp = function()
                        {
                            const element = event?.target as HTMLElement;
                            
                            if (scope.isMinimizedMode() && element?.classList.contains('dropdown-toggle'))
                                return;
                            
                            const helpSection = new HelpSection($route.current?.helpSection);
                            
                            // Broadcast event that help is opening with help section object to allow overriding help section to open
                            if ($rootScope.$broadcast('helpOpening', helpSection).defaultPrevented)
                                return;
                            
                            helpSection.open();
                        };
                        
                        $rootScope.$on('showHelp', () => {
                            scope.showHelp();
                        })
                        
                        $rootScope.$on('openHelp', function($event, section)
                        {
                            scope.openHelpSection(section);
                        })
                        
                        scope.openHelpSection = function(section: string)
                        {
                            HelpSection.openHelp(section || $route.current?.helpSection || '');
                        }
                        
                        scope.templateOrder = function (template: TemplateType) {
                            return template.name.toLowerCase();
                        };
                        
                        $('.navbar').on('hidden.bs.collapse', function () {
                            $rootScope.$broadcast('navbar-collapse');
                        });
                        
                        scope.getReportHref = function(report: Report, outputTypeName?: ReportOutputType, templateId?: number ) {
                            return `/#/report-view?log=${scope.selectedLog.id}&report=${report.id}&latest=${report.complexObject.id}`;
                        };
                        
                        scope.attemptLogout = function() {
                            /**
                             * Broadcasts logout event to allow listeners to intercept and prevent logout.
                             */
                            function logout() {
                                scope.logout();
                            }
                            
                            let event = $rootScope.$broadcast('logoutStart', logout);
                            if (event.defaultPrevented)
                                return;
                            
                            logout();
                        };
                        
                        scope.$watch('selectedLog', function (newVal: Log | undefined, oldVal: Log | undefined) {
                            if (newVal) {
                                if( !oldVal || oldVal.id != newVal.id )
                                    scope.refreshReportMenuItems();
                            }
                            else
                                delete scope.reports;
                            
                            if (newVal != null && newVal != oldVal)
                                logDataService.getLogTemplates(newVal);
                            
                            $noHoverDefaultNote = undefined;
                        });
                        
                        scope.refreshReportMenuItems = function()
                        {
                            $http.get<HALResponse<{reports: Report[]}>>('/api/reports', {
                                params: {
                                    'saveInProgress': false,
                                    'activeRevision': true,
                                    'isDraft': false,
                                    'userDetails': $rootScope.user?.id,
                                    'reportObject.log': $rootScope.selectedLog?.id,
                                    'sort': 'sortOrder',
                                    log: scope.selectedLog.id,
                                    isMenuBarItem: true
                                }
                            }).then(function(results) {
                                scope.userReports = results.data._embedded.reports;
                            });
                        }
                        scope.$on('reportMenuItemsUpdated', scope.refreshReportMenuItems);
                        
                        scope.reportLinkClicked = function(report: Report) {
                            $rootScope.$broadcast('report-link-clicked', report);
                        };
                        
                        scope.notificationBellClicked = function($event: JQueryEventObject, showMenu: boolean | undefined)
                        {
                            if (!scope.isMinimizedMode())
                            {
                                let $menu = $(elem).find('.notification-panel');
                                
                                if (typeof showMenu === 'boolean')
                                    $menu.toggleClass('hidden', !showMenu);
                                else
                                    $menu.toggleClass('hidden');
                                
                                scope.dismissToast();
                            }
                            else
                                $location.path('/notifications');
                        };
                        
                        scope.markSeen = function(notification: Notification.Projections.WithLogName): void
                        {
                            scope.dismissToast();
                            notification.seen = true;
                            notificationService.updateSeen(notification, 'seen');
                        };
                        
                        scope.isMinimizedMode = function(): boolean
                        {
                            return window.innerWidth < 768;
                        };
                        
                        /**
                         * Sets the location to note-detail and sets the context to the passed note.
                         * @param note
                         */
                        scope.openNote = (note: Note) => {
                            if (!note || !note.hasOwnProperty('_links'))
                                return;
                            
                            $timeout(() => {
                                $q.when(($rootScope.selectedLog && note.logId === $rootScope.selectedLog.id)
                                  ? $rootScope.selectedLog
                                  : logService.getLogs().toPromise().then(logs => {
                                      let log = logs.find(log => log.id == note.logId);
                                      
                                      if (!log)
                                          return $q.reject('No Log');
                                      
                                      logService.selectLog(log);
                                      
                                      return log;
                                  }))
                                  .then(log => {
                                      if (log) {
                                          $location.url('/note-detail')
                                            .search('note', note._links.self.href.replace('{?projection}', ''))
                                            .search('log', log.id);
                                          $route.reload();
                                      }
                                  })
                            });
                        };
                        
                        scope.setToasts = function(notification: Notification | Notification[])
                        {
                            if (notification == undefined) return;
                            
                            let newToasts = (Array.isArray(notification)) ? notification : [notification];
                            
                            newToasts = newToasts.filter(function(notification)
                            {
                                return notification.hasOwnProperty('toastSeen') && !notification.toastSeen
                            });
                            
                            if (newToasts.length <= 0) return;
                            
                            // Count of 'other' notifications.
                            // Increments on screen count if new appear during toast being shown.
                            var count = (scope.toast && scope.toast.count)
                              ? scope.toast.count + (newToasts.length - 1)
                              : newToasts.length - 1;
                            
                            var text = (count > 99) ? '99+ new notifications' : count + ' other new notifications';
                            
                            scope.toast = { notification: newToasts[0], count: count, text: text };
                            scope.registerHtmlToast()
                            notificationService.markAllToastsSeen();
                        };
                        
                        scope.registerHtmlToast = function()
                        {
                            $timeout.cancel(scope.dismissTimeout);
                            $timeout(function()
                            {
                                scope.dismissTimeout = $timeout(function()
                                {
                                    scope.dismissToast()
                                }, 15000);
                                $('.notification').fadeIn();
                            })
                        };
                        
                        scope.dismissToast = function()
                        {
                            $('.notification').fadeOut(() => {
                                scope.toast = {};
                            })
                        };
                        
                        scope.openNotificationModal = function(notification: Notification, $event?: JQueryEventObject)
                        {
                            if ($event && $event.isDefaultPrevented()) return;
                            scope.notification = notification;
                            $('#notification-modal').modal('show');
                        };
                        
                        scope.closeNotificationModal = function()
                        {
                            $('#notification-modal').modal('hide');
                        };
                        
                        // .dropdown-toggle <a>'s can use this function to simultaneously function as both toggles on hover and to change the URL on click.
                        // <a>'s in a .dropdown-menu can use it to avoid losing their query string parameters when setting the same path as the current route.
                        scope.navigateTo = function(path: string | 'HOME') {
                            event?.preventDefault();
                            
                            if (path === 'HOME' && $rootScope.selectedLog) {
                                LogService.navigateToSelectedLogHomePage($location);
                                return;
                            }
                            
                            let dropdownToggleClicked = (<JQueryEventObject | undefined> event)?.target?.classList.contains('dropdown-toggle');
                            
                            if (path != $location.path() && (!dropdownToggleClicked
                              ||
                              (
                                // $hamburger.is(':hidden') &&
                                $rootScope.hoverSupported &&
                                !scope.isTouchPointer))
                            )
                            {
                                $location.url(path)
                                if ($rootScope.selectedLog && $rootScope.selectedLog.id)
                                    $location.search('log', $rootScope.selectedLog.id);
                            }
                        };
                        
                        scope.openVideoTips = () => {
                            persistentDialogService.next({
                                component: VideoTipsViewerComponent,
                                settings: {
                                    header: "Video Guides",
                                    fullscreen: true
                                }
                            })
                        }
                        
                        $(window).on('resize', function()
                        {
                            $timeout(function()
                            {
                                if (scope.isMinimizedMode())
                                    $(elem).find('.notification-panel').toggleClass('hidden', true);
                            });
                        });
                        
                        // For closing the notification panel when clicking anywhere BUT the notification panel
                        // stops propagation of document clicks on notification panel
                        // any clicks still propagating will close the notification panel
                        $(document)
                          .on('click', '#notification-panel, #notification-bell, #notification-modal', function($event)
                          {
                              $event.stopPropagation();
                          })
                          .click(function($event)
                          {
                              if (!scope.isMinimizedMode())
                                  $(elem).find('.notification-panel').toggleClass('hidden', true);
                          });
                        
                        scope.$on('$routeChangeStart', function()
                        {
                            $('.notification-panel').toggleClass('hidden', true);
                            scope.closeNotificationModal();
                        });
                        
                        scope.$on('$routeChangeSuccess', function(event: IAngularEvent, current: IRouteEventRoute, previous: IRouteEventRoute)
                        {
                            scope.showNavBar = current.$$route.showNavBar ?? true;
                        });
                        
                        scope.$on('$locationChangeSuccess', function() {
                            scope.onHomePage = LogService.getSelectedLogHomePage().includes($location.path().replace('/', ''));
                        })
                        
                        // Defined and two-way bound in reportBuilderStarter directive
                        scope.showNewReportModal = null;
                    }
                },
                
            }
        }]);